import React from 'react';
import { useTheme} from '@mui/material';
import Select from 'react-select';
import { useLanguage } from '../../i18n';
import { NumberListItem } from '../../store/refund/types';
import './dropdownSelector.scss';

type Props = {
    selectedValue: NumberListItem;
    disabledValue?: number;
    disabledAbove?: boolean;
    onChange: (year: NumberListItem) => void;
    selectionList: NumberListItem[];
    header?: string;
};

export default function DropdownSelector(props: Props): React.ReactElement {
    const theme = useTheme();
    const l = useLanguage();
    const adjustedStyles = {
        control: base => ({ ...base, backgroundColor: 'white' }),
        menu: (base) => ({
            ...base,
            position: 'absolute',
            width: '100%',
            zIndex: '30',
            marginTop: 0
        }),
        option: (base, { isDisabled, isFocused, isSelected }) => {
            return {
                ...base,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                    ? theme.palette.secondary.main
                    : isFocused
                    ? theme.palette.secondary.dark
                    : null,
                color: isDisabled ? '#ccc' : isSelected,
                cursor: isDisabled ? 'not-allowed' : 'default',
                fontWeight: isSelected ? 'bold' : 'normal',

                ':active': {
                    ...base[':active'],
                    backgroundColor: !isDisabled && (isSelected ? theme.palette.secondary.main : theme.palette.secondary.dark),
                },
            };
        },
    };
    const ariaLabel = props.header ? props.header : 'select';
    const isDisabled = (value: NumberListItem): boolean => {
        return props.disabledValue && props.disabledAbove
            ? value.value > props.disabledValue
            : value.value < props.disabledValue;
    };
    const handleChange = (value: NumberListItem): void => {
        const selected = props.selectionList.find(x => x.value === value.value);
        props.onChange(selected);
    };

    return (
        <label>
            <span className="select-year-label">{props.header}</span>
            <Select
                className="select-year"
                value={props.selectedValue}
                isOptionDisabled={isDisabled}
                isClearable={false}
                isSearchable={true}
                onChange={handleChange}
                name="year"
                options={props.selectionList}
                aria-label={ariaLabel}
                styles={adjustedStyles}
                noOptionsMessage={() => l('searchableSelect.noOptionsMessage')}
            />
        </label>
    );
}
